<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Delitos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-toolbar-items>
                  <v-btn dark text v-on="on">
                    Nuevo
                  </v-btn>
                </v-toolbar-items>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.nombre" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            :items="listMaterias"
                            v-model="editedItem.materia_id"
                            label="Materia"
                            item-value="id"
                            item-text="nombre"
                            :rules="notBlankRules"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" @click.native="editDelito()" :disabled="!valid" :loading="loading" class="white--text">Actualizar</v-btn>
                          <v-btn v-else color="yellow darken-2" @click.native="addDelito(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-card-title>
            <v-row>
              <v-col cols="12" md="9">
                <v-text-field
                  label="Filtrar por Delito"
                  v-model="nombre_delito"
                  clearable
                  @change="getDelitos()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  label="Filtrar por Materia"
                  :items="listMaterias"
                  v-model="materia_id"
                  item-value="id"
                  item-text="nombre"
                  clearable
                  v-on:change="getDelitos()"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="listDelitos"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="per_page_table"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.action="{ item }">
              <v-icon color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon v-if="!item.deleted_at" color="red"  @click="deleteDelito(item)">mdi-close</v-icon>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
              >mdi-check-bold</v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
              >mdi-minus</v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="pagination.total > 1">
            <v-pagination v-model="pagination.current" :length="pagination.total" :total-visible='7' @input="onPageChange"></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      nombre_delito:'',
      materia_id:'',
      activo: true,
      valid: true,
      dialog: false,
      loading:false,
      pagination: {
        current: 1,
        total: 0
      },
      per_page_table: 20,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      listDelitos: [],
      // show: false,
      headers: [
        { text: 'Delito', value: 'nombre', sortable: false },
        { text: 'Materia', value: 'materia_nombre', sortable: false, align: 'left' },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action', sortable: false, width: '9%' }
      ],
      editedIndex: -1,
      editedItem: {
        materia_id:'',
        nombre:'',
      },
      defaultItem: {
        materia_id:'',
        nombre:'',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters([
      "listMaterias",
    ]),
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Delito/Acción' : 'Editar Delito/Acción'
    },
  },
  mounted() {
    this.getDelitos();
    this.getMaterias();
  },
  watch: {
    nombre_delito: function (val) {
      this.pagination.current = 1;
      if(!val){
        this.pagination.current = 1;
        // this.nombre_delito = '',
        this.getDelitos()
      }
    },
    materia_id: function (valor) {
      this.pagination.current = 1;
      this.getDelitos()
      if(!valor){
        // this.materia_id = '',
        this.pagination.current = 1;
        this.getDelitos()
      }
    },
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    onPageChange() {
      this.getDelitos();
    },
    getDelitos() {
      this.loading = true;
      // this.$store.dispatch("GET_DELITOS", { url: "/delitos"}).then((response) => {
      this.$store.dispatch("GET_DELITOS", { url: "/delitos?page=" + this.pagination.current,
        data: {
          nombre_delito: this.nombre_delito,
          materia_id: this.materia_id
        }
      }).then((response) => {
        // console.log(response.data.data.delitos.current_page);
        this.loading = false;
        this.listDelitos = response.data.data.delitos.data;
        this.pagination.current = response.data.data.delitos.current_page;
        this.pagination.total = response.data.data.delitos.last_page;
        this.per_page_table = response.data.data.delitos.per_page;
      })
      .catch(err => {
        console.log(err);
      });
    },
    getMaterias() {
      this.loading = true;
      this.$store.dispatch("GET_MATERIAS",  { url: "/materias" } ).then(response => {
        // console.log(response.data.data.materias);
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    },

    editItem (item) {
      this.editedIndex = this.listDelitos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (this.editedItem.deleted_at) this.activo = false
      else this.activo = true
      this.dialog = true
    },
    addDelito(item){
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("SAVE_DELITO",  { url: "/delito", data: item } ).then(response => {
          this.close ();
          this.$swal({
            icon: 'success',
            title: 'Delito guardado correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getDelitos();
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    editDelito(){
      if (this.$refs.form.validate()) {
        this.loading = true;
        var data = {};
        data.materia_id = this.editedItem.materia_id
        data.nombre = this.editedItem.nombre
        data.activo = this.activo
        this.$store.dispatch("EDIT_DELITO",  { url: "/delito/" + this.editedItem.id, data: data} ).then(response => {
          this.$swal({
            icon: 'success',
            title: 'Delito actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.close();
          this.getDelitos();
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    deleteDelito(item){
      this.$swal({
        title: '¿Desea eliminar Delito "' + item.nombre + '"?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.$store.dispatch("DELETE_DELITO",  { url: "/delito/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Delito eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getDelitos();
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
